import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import {
  smallestStripSelector,
  timestampSelector,
} from '../../navigation/selectors/navigation.selectors';
import { MINIMUM_RULER_DURATION } from '../../ruler/utils/ruler.utils';

export const ruler2dSelector = ({ ruler2d }: DefaultRootState) => ruler2d;

export const ruler2dUpdateModeSelector = createSelector(
  ruler2dSelector,
  ({ updateMode }) => updateMode,
);

export const previousRuler2dTimestampSelector = createSelector(
  timestampSelector,
  ruler2dSelector,
  (timestamp, state) =>
    state.updateMode === 'move' ? state.previousTimestamp : timestamp,
);

export const isMovingRuler2dSelector = createSelector(
  ruler2dUpdateModeSelector,
  (updateMode) => updateMode === 'move',
);

export const isUpdatingRuler2dSelector = createSelector(
  ruler2dSelector,
  ({ updateMode }) => updateMode != null,
);

export const ruler2dTimestampRangeSelector = createSelector(
  ruler2dSelector,
  ({ timestampStart, timestampEnd }) => [
    Math.min(timestampStart, timestampEnd),
    Math.max(timestampStart, timestampEnd),
  ],
);

export const ruler2dVoltageRangeSelector = createSelector(
  ruler2dSelector,
  ({ voltageStart, voltageEnd }) => [
    Math.min(voltageStart, voltageEnd),
    Math.max(voltageStart, voltageEnd),
  ],
);

export const ruler2dPointsSelector = createSelector(
  ruler2dTimestampRangeSelector,
  roundedDurationSelector,
  smallestStripSelector,
  ([start, end], ecgDuration, strip) => {
    const { onset: sOnset = 0, offset: sOffset = 0 } = strip || {};
    const rulerDuration = end - start;
    const absoluteStart = start % rulerDuration;
    const points: number[] = [];
    let current = absoluteStart;

    while (
      current < ecgDuration + sOffset + sOnset &&
      rulerDuration > MINIMUM_RULER_DURATION
    ) {
      if (current !== start && current !== end) {
        points.push(current);
      }
      current += rulerDuration;
    }
    return points;
  },
);
